import { Stack, type StackProps } from "@chakra-ui/react";

interface QuestionContentProps extends StackProps {
  gap?: StackProps["gap"];
}

const QuestionContent = ({ gap, children, ...props }: QuestionContentProps) => {
  return (
    <Stack w="full" gap={gap} {...props}>
      {children}
    </Stack>
  );
};

export { QuestionContent };
export type { QuestionContentProps };
